import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DocumentAdjustmentWrongInventoryEffectError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.common.validation.document-adjustment.wrong-inventory-effect');
    }
}
